import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Sortable from 'sortablejs';
import BarbersListItem from './BarbersListItem';
import TimeTrackingHeaderColumn from '../../timeTracker/containers/BarberListHeaderColumn';

class BarbersList extends Component {
  constructor(props) {
    super(props);
    this.sortableInstance = null;
    this.isDragging = false;
    this.dragTimeout = null;
  }

  componentDidMount() {
    if (this.props.isSortable) {
      this.setupSortable();
    }
  }

  componentWillUnmount() {
    if (this.props.isSortable) {
      this.sortableInstance.destroy();
    }
  }

  onStart = () => {
    this.isDragging = true;
    clearTimeout(this.dragTimeout);
  }

  onEnd = () => {
    this.isDragging = false;
  }

  onSort = (e) => {
    const { barbers, onSortChange } = this.props;
    this.arrayMove(barbers, e.oldIndex, e.newIndex);
    this.dragTimeout = setTimeout(() => {
      if (this.isDragging) return;
      onSortChange(barbers);
    }, 600);
  }

  setupSortable() {
    this.sortableInstance = Sortable.create(this._sortableBarbers, {
      group: '',
      handle: '.sortable-handle',
      forceFallback: true,
      draggable: '.c-table-card__row',
      onStart: this.onStart,
      onEnd: this.onEnd,
      onSort: this.onSort,
    });
  }

  arrayMove(arr, fromIndex, toIndex) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  render() {
    const { barbers, isBrandView } = this.props;
    let barbersList;
    if (barbers) {
      barbersList = barbers.map(barber => (
        <BarbersListItem barber={barber} key={barber.id} isBrandView={isBrandView} isSortable={this.props.isSortable} />
      ));
    }

    return (
      <div className="c-table-with-sticky-header u-position-relative u-mb+">
        <div className="u-scrollable-visible">
          <div className="c-table-card c-table-new c-sticky-header u-no-shadow u-table-layout-fixed">
            <div className="c-table-card__head">
              <div className="c-table-card__cell c-label u-1/10" display-if={this.props.isSortable}>Sort</div>
              <div className="c-table-card__cell c-label u-2/10">Barber</div>
              <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-2/10">Email</div>
              <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-1/10">Phone</div>
              <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-1/10">
                Personnel ID
              </div>
              <TimeTrackingHeaderColumn display-if={!isBrandView} />
              <div
                className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-3/10"
                display-if={isBrandView}
              >
                Locations
              </div>
            </div>
          </div>
          <div className="c-table-card c-table-new u-table-layout-fixed u--mt--" ref={el => this._sortableBarbers = el}>
            {barbersList}
          </div>
        </div>
      </div>
    );
  }
}

BarbersList.propTypes = {
  barbers: PropTypes.array.isRequired,
  onSortChange: PropTypes.func.isRequired,
  isBrandView: PropTypes.bool.isRequired,
  isSortable: PropTypes.bool.isRequired,
};

export default BarbersList;
